import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoadingSpinnerProps {
  height?: string | number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ height = '400px' }) => {
  return (
    <Box
      data-testid="loading-spinner"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: height,
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingSpinner;
